module.exports = __webpack_public_path__ + "img/changzhou02.63f96175.png";